import { render } from "./Home.vue?vue&type=template&id=56112bb7&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__